import * as React from 'react';
import { View, Text, StyleSheet, Svg, Path } from '@react-pdf/renderer';

const styles = StyleSheet.create({
  text: {
    fontWeight: 400,
    fontSize: '13px',
    color: 'rgba(105, 105, 105, 1)',
    marginLeft: '8px',
    textAlign: 'center',
  },
});

export const Footer: React.FC = () => {
  return (
    <View
      fixed
      style={{
        width: '100%',
        alignSelf: 'flex-end',
        display: 'flex',
        flexDirection: 'row',
        justifyContent: 'space-around',
        position: 'absolute',
        bottom: 10,
        left: 0,
      }}
    >
      <View style={{ display: 'flex', flexDirection: 'row' }}>
        <Svg width="12" height="16" viewBox="0 0 12 16">
          <Path
            d="M2.4655 2.80625C2.92845 2.33982 3.47907 1.96956 4.08568 1.71678C4.69229 1.46399 5.34291 1.33368 6.00008 1.33333C7.32508 1.33333 8.59675 1.8625 9.53467 2.80625C10.474 3.75256 11.0008 5.03206 11.0001 6.36542C11.0001 8.66792 9.72342 10.7521 8.39342 12.2908C7.83295 12.9361 7.2253 13.5389 6.5755 14.0942C6.38762 14.2553 6.19576 14.4117 6.00008 14.5633C5.80449 14.4116 5.61263 14.2552 5.42467 14.0942C4.77486 13.5389 4.16722 12.9361 3.60675 12.2908C2.27675 10.7521 1.00008 8.66792 1.00008 6.36542C1.00008 5.03 1.52758 3.75 2.4655 2.80625ZM5.76008 15.4237L6.00008 15.0833L6.24008 15.4237C6.16979 15.4731 6.08598 15.4996 6.00008 15.4996C5.91418 15.4996 5.83037 15.4731 5.76008 15.4237ZM5.76008 15.4237L6.00008 15.0833L6.24008 15.4237L6.24175 15.4229L6.24592 15.42L6.25842 15.4104L6.30758 15.375C6.34925 15.3442 6.41008 15.2992 6.48675 15.24C6.64008 15.1225 6.85758 14.9496 7.11717 14.7275C7.79859 14.1451 8.43576 13.5128 9.02342 12.8358C10.4017 11.2417 11.8334 8.96625 11.8334 6.365C11.8334 4.81083 11.2192 3.31917 10.1259 2.21917C9.58551 1.67475 8.94277 1.24258 8.23469 0.947531C7.52661 0.652486 6.76717 0.500391 6.00008 0.5C5.23302 0.500336 4.4736 0.652366 3.76552 0.947339C3.05744 1.24231 2.41469 1.6744 1.87425 2.21875C0.779842 3.32126 0.166013 4.81195 0.166749 6.36542C0.166749 8.96625 1.59842 11.2417 2.97675 12.8358C3.5644 13.5128 4.20158 14.1451 4.883 14.7275C5.143 14.9496 5.36008 15.1225 5.51342 15.24C5.58862 15.298 5.6646 15.3549 5.74133 15.4108L5.75467 15.42L5.75842 15.4229L5.76008 15.4237ZM4.33342 6.33333C4.33342 5.89131 4.50901 5.46738 4.82157 5.15482C5.13413 4.84226 5.55805 4.66667 6.00008 4.66667C6.44211 4.66667 6.86603 4.84226 7.17859 5.15482C7.49115 5.46738 7.66675 5.89131 7.66675 6.33333C7.66675 6.77536 7.49115 7.19928 7.17859 7.51184C6.86603 7.8244 6.44211 8 6.00008 8C5.55805 8 5.13413 7.8244 4.82157 7.51184C4.50901 7.19928 4.33342 6.77536 4.33342 6.33333ZM6.00008 3.83333C5.33704 3.83333 4.70116 4.09673 4.23232 4.56557C3.76347 5.03441 3.50008 5.67029 3.50008 6.33333C3.50008 6.99637 3.76347 7.63226 4.23232 8.1011C4.70116 8.56994 5.33704 8.83333 6.00008 8.83333C6.66312 8.83333 7.29901 8.56994 7.76785 8.1011C8.23669 7.63226 8.50008 6.99637 8.50008 6.33333C8.50008 5.67029 8.23669 5.03441 7.76785 4.56557C7.29901 4.09673 6.66312 3.83333 6.00008 3.83333Z"
            fill="#696969"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
        </Svg>
        <Text style={styles.text}>31 Lechi St. , Bnei Brak, Israel.</Text>
      </View>
      <View style={{ display: 'flex', flexDirection: 'row' }}>
        <Svg width="16" height="16" viewBox="0 0 16 16">
          <Path
            d="M14.2699 10.3548C13.4758 10.2568 12.6872 10.1179 11.9074 9.93855C11.717 9.87492 11.5135 9.86151 11.3164 9.89962C11.1193 9.93772 10.9354 10.026 10.7824 10.1561C10.5837 10.3586 10.0099 10.9248 9.41368 11.5098C7.27739 10.4596 5.54971 8.73064 4.50118 6.59355C5.08243 5.9973 5.62618 5.4273 5.84743 5.22855C5.97744 5.07561 6.06576 4.89169 6.10387 4.69461C6.14197 4.49752 6.12856 4.29394 6.06493 4.10355C5.88539 3.32253 5.74645 2.53272 5.64868 1.7373C5.63821 1.63601 5.60721 1.53792 5.55759 1.44899C5.50798 1.36007 5.44077 1.28219 5.36007 1.22008C5.27937 1.15798 5.18687 1.11296 5.0882 1.08777C4.98954 1.06257 4.88677 1.05774 4.78618 1.07355H1.59118C1.4593 1.08546 1.33585 1.14351 1.24256 1.23749C1.14927 1.33146 1.09212 1.45534 1.08118 1.5873C0.87493 4.47105 2.48368 7.5573 2.80993 8.1498V8.1723L2.85493 8.25855C4.02281 10.2841 5.70439 11.9657 7.72993 13.1336V13.1336L7.89493 13.2273C8.64493 13.6248 11.6262 15.1248 14.4124 14.9186C14.5457 14.9093 14.6714 14.8529 14.7669 14.7595C14.8624 14.666 14.9215 14.5416 14.9337 14.4086V11.2173C14.9495 11.1167 14.9447 11.0139 14.9195 10.9153C14.8943 10.8166 14.8493 10.7241 14.7872 10.6434C14.725 10.5627 14.6472 10.4955 14.5582 10.4459C14.4693 10.3963 14.3712 10.3653 14.2699 10.3548Z"
            stroke="#696969"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
        </Svg>
        <Text style={styles.text}>+972 52 656 7777</Text>
      </View>

      <View
        style={{
          display: 'flex',
          flexDirection: 'row',
          justifyContent: 'center',
          alignItems: 'center',
        }}
      >
        <Svg width="16" height="12" viewBox="0 0 16 12">
          <Path
            d="M13.88 2.44961L8.00002 6.77711L2.12002 2.44961M1.42627 1.01711C1.22736 1.01711 1.03659 1.09613 0.89594 1.23678C0.755287 1.37743 0.67627 1.5682 0.67627 1.76711V10.2459C0.67627 10.4448 0.755287 10.6355 0.89594 10.7762C1.03659 10.9168 1.22736 10.9959 1.42627 10.9959H14.5738C14.7727 10.9959 14.9634 10.9168 15.1041 10.7762C15.2448 10.6355 15.3238 10.4448 15.3238 10.2459V1.75586C15.3238 1.55695 15.2448 1.36618 15.1041 1.22553C14.9634 1.08488 14.7727 1.00586 14.5738 1.00586H1.42627V1.01711Z"
            stroke="#696969"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
        </Svg>

        <Text style={styles.text}>team@patricia-ai.com</Text>
      </View>
    </View>
  );
};
